module.exports = __webpack_public_path__ + "static/media/i_review_star_on.4b764e30.png";